export default __webpack_public_path__ + "static/seroja-impact-00361acc8ce9bc4cb103eade5ce1a975.jpg";